import { ListItem, Typography } from '@mui/material'

const TermsListItem: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <ListItem sx={{ display: 'list-item' }}>
    {typeof children === 'string' ? <Typography variant="body1">{children}</Typography> : children}
  </ListItem>
}

export default TermsListItem
